import { baseillustMasterRecords } from "./records/baseillust-master-records";
import IBaseillustMaster from "../interfaces/masters/baseillust-master-interface";

class BaseillustMaster implements IBaseillustMaster {
  id: Number;
  fileName: String; // 選択の場合
  src?: String; // アップロードの場合

  static readonly UploadedId = 999999;

  constructor(record: IBaseillustMaster) {
    this.id = record.id;
    this.fileName = record.fileName;
    if (record.src) {
      this.src = record.src;
    }
  }

  public isUploaded() {
    return BaseillustMaster.UploadedId == this.id;
  }

  /**
   * レコード取得
   */
  public static records: IBaseillustMaster[] = baseillustMasterRecords;
}

export default BaseillustMaster;
